import React from 'react';

function Linkedin() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='36'
      height='36'
      viewBox='0 0 50 50'>
      <path d='M25 2C12.3 2 2 12.3 2 25s10.3 23 23 23 23-10.3 23-23S37.7 2 25 2zm-6 33c0 .5-.5 1-1 1h-4c-.5 0-1-.5-1-1V20c0-.5.5-1 1-1h4c.5 0 1 .5 1 1v15zm-3-17c-1.6 0-3-1.4-3-3s1.4-3 3-3 3 1.4 3 3-1.4 3-3 3zm22 17c0 .5-.5 1-1 1h-4c-.5 0-1-.5-1-1v-7.5c0-1.4-1.1-2.5-2.5-2.5S27 26.1 27 27.5V35c0 .5-.5 1-1 1h-4c-.5 0-1-.5-1-1V20c0-.5.5-1 1-1h4c.5 0 1 .4 1 1 1.1-.6 2.2-1 3.5-1 4.1 0 7.5 3.4 7.5 7.5V35z'></path>
    </svg>
  );
}

export default Linkedin;
